
/*
Defines the custom element <ravel-blockly>
*/

import { RavelBlockly } from './src/RavelBlockly.js';

customElements.define('ravel-blockly', RavelBlockly);
